import React, { useState } from "react";

import { trackHelpFeedback } from "../../lib/analytics";

/**
 * "Jawaban ini sudah membantu?" under every article. Both answers are sent with
 * the article id (lib/analytics.js); "Belum terjawab" is the one the content
 * team asked for, to find articles that do not answer what they promise.
 *
 * After an answer the block thanks the reader and, on "belum", hands them the
 * chat -- an unanswered question should not end at a thank-you.
 */
const FeedbackBlock = ({ articleId, chatUrl }) => {
  const [answer, setAnswer] = useState(null);

  const send = helpful => {
    trackHelpFeedback(articleId, helpful);
    setAnswer(helpful ? "yes" : "no");
  };

  if (answer === "yes") {
    return (
      <div className="hc-helpful" role="status">
        <p className="hc-helpful__q">Makasih ya! Senang bisa bantu.</p>
      </div>
    );
  }

  if (answer === "no") {
    return (
      <div className="hc-helpful" role="status">
        <p className="hc-helpful__q">Makasih sudah kasih tahu. Team Kyou bisa bantu langsung lewat chat.</p>
        <div className="hc-helpful__btns">
          <a className="hc-btn" href={chatUrl} target="_blank" rel="noopener noreferrer">
            Chat Team Kyou
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="hc-helpful">
      <p className="hc-helpful__q">Jawaban ini sudah membantu?</p>
      <div className="hc-helpful__btns">
        <button type="button" className="hc-btn hc-btn--ghost" onClick={() => send(true)}>
          Ya, sudah jelas
        </button>
        <button type="button" className="hc-btn hc-btn--ghost" onClick={() => send(false)}>
          Belum terjawab
        </button>
      </div>
    </div>
  );
};

export default FeedbackBlock;
